import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
} from 'react-icons/fa';

const socialLinks = [
  {
    key: 'instagram',
    label: 'Instagram',
    url: 'https://www.instagram.com/bigsport.com.ua/',
    icon: FaInstagram,
  },
  {
    key: 'youtube',
    label: 'YouTube',
    url: 'https://www.youtube.com/@BigSport-TV1',
    icon: FaYoutube,
  },
  {
    key: 'facebook',
    label: 'Facebook',
    url: 'https://www.facebook.com/profile.php?id=61587925061004',
    icon: FaFacebookF,
  },
  {
    key: 'linkedin',
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/company/bigsport',
    icon: FaLinkedin,
  },
];

export default socialLinks;
